document.addEventListener('DOMContentLoaded', () => {
  const productTabsContainer = document.querySelector('.featured-collection-tabs');
  const productTabsButtons = productTabsContainer?.querySelectorAll('.collection-tab-titles button');

  productTabsButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const tabIndex = this.getAttribute('data-tab-index');

      removeAllActiveTabs();

      if (tabIndex) {
        const selectedProductsTab = productTabsContainer.querySelector(`.featured-collection-tab[data-tab-index="${tabIndex}"]`);
        selectedProductsTab?.classList.remove('hidden');
      }

      this.classList.add('active');
    });
  });
});


function removeAllActiveTabs() {
  const productTabsContainer = document.querySelector('.featured-collection-tabs');
  const productTabsButtons = productTabsContainer?.querySelectorAll('.collection-tab-titles button');
  const productTabs = productTabsContainer?.querySelectorAll('.featured-collection-tab');

  productTabsButtons.forEach(function(button) {
    button.classList.remove('active');
  });

  productTabs.forEach(function(tab) {
    tab.classList.add('hidden');
  });
}